__turbopack_context__.v({
  "separator": "HeadlineSeparator-module__HwYvQW__separator",
});
